// OVERRIDES - TAB
export default function Tab(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 46,
          color: theme.palette.text.primary,
          borderRadius: "50px",

          "&.Mui-selected": {
            backgroundColor: "#e6f2ff",
          },

          '&:hover': {
            backgroundColor: "#e6f2ff",
            color: theme.palette.primary.main
          },
          '&:focus-visible': {
            backgroundColor: "#e6f2ff",
          }
        }
      }
    }
  };
}
